
  // 获取APP中环境链接  参数data为h5路由
  export function getNativeLocation(data) {
    const inputData = window.location.hostname
    let locationUrl = ''
    if (inputData === 'saasapph5.dev.ybm100.com') {
      locationUrl = 'https://xmall.dev.ybm100.com/#/' + data
    } else if (inputData === 'saasapph5.test.ybm100.com') {
      locationUrl = 'https://xmall.test.ybm100.com/#/' + data
    } else if (inputData === 'saasapph5.ybm100.com') {
      locationUrl = 'https://xmall.ybm100.com/#/' + data
    } else if (inputData === 'localhost') {
      locationUrl = 'https://xmall.test.ybm100.com/#/' + data
    } else {
      locationUrl = 'https://xmall.ybm100.com/#/' + data
    }
    return locationUrl
  }
  